import { call, put, takeEvery } from 'redux-saga/effects'

import * as api from 'api'
import {
  FETCH_USER_INFO,
  FETCH_USER_INFO_SUCCESS,
  FETCH_USER_INFO_ERROR,
  CREATE_EXPERIENCE,
  CREATE_EXPERIENCE_SUCCESS,
  CREATE_EXPERIENCE_ERROR,
  UPDATE_EXPERIENCE,
  UPDATE_EXPERIENCE_SUCCESS,
  UPDATE_EXPERIENCE_ERROR,
  DELETE_EXPERIENCE,
  DELETE_EXPERIENCE_SUCCESS,
  DELETE_EXPERIENCE_ERROR,
} from 'actionTypes'

function* fetchUserInfo({ id }) {
  try {
    const userInfo = yield call(api.fetchUserInfo, id)
    yield put({ type: FETCH_USER_INFO_SUCCESS, id, userInfo })
  } catch ({ message }) {
    yield put({ type: FETCH_USER_INFO_ERROR, id, message })
  }
}

function* createExperience({ consultantId, experience }) {
  try {
    const experienceId = yield call(
      api.createExperience,
      consultantId,
      experience
    )
    yield put({
      type: CREATE_EXPERIENCE_SUCCESS,
      consultantId,
      experienceId,
      experience,
    })
  } catch ({ message }) {
    yield put({
      type: CREATE_EXPERIENCE_ERROR,
      message,
      consultantId,
      experience,
    })
  }
}

function* updateExperience({ consultantId, experienceId, experience }) {
  try {
    yield call(api.updateExperience, consultantId, experienceId, experience)
    yield put({
      type: UPDATE_EXPERIENCE_SUCCESS,
      consultantId,
      experienceId,
      experience,
    })
  } catch ({ message }) {
    yield put({
      type: UPDATE_EXPERIENCE_ERROR,
      message,
      consultantId,
      experienceId,
      experience,
    })
  }
}

function* deleteExperience({ consultantId, experienceId }) {
  try {
    yield call(api.deleteExperience, consultantId, experienceId)
    yield put({
      type: DELETE_EXPERIENCE_SUCCESS,
      consultantId,
      experienceId,
    })
  } catch ({ message }) {
    yield put({
      type: DELETE_EXPERIENCE_ERROR,
      message,
      consultantId,
      experienceId,
    })
  }
}

function* saga() {
  yield takeEvery(FETCH_USER_INFO, fetchUserInfo)
  yield takeEvery(CREATE_EXPERIENCE, createExperience)
  yield takeEvery(UPDATE_EXPERIENCE, updateExperience)
  yield takeEvery(DELETE_EXPERIENCE, deleteExperience)
}

export default saga



// WEBPACK FOOTER //
// ./src/sagas/users.js